/**
 * Remove BOM, zero-width e espaços Unicode invisíveis antes do trim padrão.
 */
function sanitizarChaveMatricula(valor: string): string {
  return valor
    .replace(/[\uFEFF\u200B-\u200D\u2060]/g, "")
    .replace(/[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, "")
    .trim();
}

/**
 * Normaliza chave para comparação (alinhado ao backend: lowercase, sem hífen/underscore).
 */
function normalizarChaveParaComparacao(valor: string): string {
  return sanitizarChaveMatricula(valor).replace(/[-_]/g, "").toLowerCase();
}

export { normalizarChaveParaComparacao, sanitizarChaveMatricula };
